// assets
import { 
  DashboardOutlined,
  ShopOutlined,
  ShoppingOutlined,
  TeamOutlined,
  CheckCircleOutlined,
  BellOutlined,
  LinkOutlined,
  FileTextOutlined,
  TagsOutlined,
  ShoppingCartOutlined,
  UnorderedListOutlined,
  CopyOutlined
} from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  ShopOutlined,
  ShoppingOutlined,
  TeamOutlined,
  CheckCircleOutlined,
  BellOutlined,
  LinkOutlined,
  FileTextOutlined,
  TagsOutlined,
  ShoppingCartOutlined,
  UnorderedListOutlined,
  CopyOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Navegação',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'promoters',
      title: 'Promotores',
      type: 'item',
      url: '/promoters',
      icon: icons.TeamOutlined,
      breadcrumbs: false
    },
    {
      id: 'stores',
      title: 'Lojas',
      type: 'item',
      url: '/stores',
      icon: icons.ShopOutlined,
      breadcrumbs: false
    },
    {
      id: 'marcas',
      title: 'Marcas',
      type: 'item',
      url: '/marcas',
      icon: icons.TagsOutlined,
      breadcrumbs: false
    },
    {
      id: 'products',
      title: 'Produtos',
      type: 'item',
      url: '/products',
      icon: icons.ShoppingOutlined,
      breadcrumbs: false
    },
    {
      id: 'task-templates',
      title: 'Templates de Tarefas',
      type: 'item',
      url: '/task-templates',
      icon: icons.CopyOutlined,
      breadcrumbs: false
    },
    {
      id: 'visits',
      title: 'Visitas',
      type: 'item',
      url: '/visits',
      icon: icons.CheckCircleOutlined,
      breadcrumbs: false
    },
    {
      id: 'reports',
      title: 'Relatórios',
      type: 'collapse',
      icon: icons.FileTextOutlined,
      children: [
        {
          id: 'visits-report',
          title: 'Relatório de Visitas',
          type: 'item',
          url: '/visits/report',
          icon: icons.FileTextOutlined,
          breadcrumbs: false
        }
      ]
    },
    {
      id: 'alerts',
      title: 'Alertas',
      type: 'item',
      url: '/alerts',
      icon: icons.BellOutlined,
      breadcrumbs: false
    }
    // TEMPORARIAMENTE DESATIVADO
    // {
    //   id: 'reports',
    //   title: 'Relatórios',
    //   type: 'item',
    //   url: '/reports',
    //   icon: icons.FileTextOutlined,
    //   breadcrumbs: false
    // },
    // {
    //   id: 'pedidos',
    //   title: 'Pedidos',
    //   type: 'item',
    //   url: '/pedidos',
    //   icon: icons.ShoppingCartOutlined,
    //   breadcrumbs: false
    // }
  ]
};

export default dashboard;
